import { peopleTypes, serializedTypes } from '@/reports/types';
import { DateUtil } from '@/utils/index';
import { ReportSectionData } from '../helperTypes';

/**
 * Check if meta data is present and returns formatted first and last date seen.
 * @param data
 * @returns Formatted dates seen.
 */
export const getDatesSeen = (
  data: Exclude<
    ReportSectionData,
    | serializedTypes.SerializedPerson
    | peopleTypes.UCC
    | peopleTypes.DEA
    | peopleTypes.Sporting
    | peopleTypes.Business
    | peopleTypes.FAA
    | peopleTypes.Professional
    | peopleTypes.Weapon
  >
) => {
  const date = new DateUtil();
  const DATE_FORMAT = 'LLL yyyy';
  let firstSeenDate;
  let lastSeenDate = null;

  if (data.meta?.first_seen_date?.full) {
    firstSeenDate = date.parseDateFromString(
      data.meta.first_seen_date.full,
      DATE_FORMAT
    );
  }

  if (data.meta?.last_seen_date?.full) {
    lastSeenDate = date.parseDateFromString(
      data.meta.last_seen_date.full,
      DATE_FORMAT
    );
  }

  if (firstSeenDate && lastSeenDate) {
    return `${firstSeenDate} - ${lastSeenDate}`;
  }

  return firstSeenDate || lastSeenDate || '';
};
